export default () => ({
  alert: {},
  isActive: false,
});
